import React from 'react';
import './ConfirmModal.css';

function DownloadConfirmModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">Are you done tuning the parameters?</h3>
        <div className="modal-body">
          <p>
            Once the download is completed, <strong>your data will be deleted</strong> from the server.
          </p>
          <p>
            To adjust the predictions, please go back to the start and re-train the model.
          </p>
        </div>
        <div className="modal-actions">
          <button className="button button-secondary" onClick={onCancel}>
            ← Go Back
          </button>
          <button className="button" onClick={onConfirm}>
            Download &amp; Delete →
          </button>
        </div>
      </div>
    </div>
  );
}

export default DownloadConfirmModal;
